import React from 'react'

export default function PageHeader( props ) {

	return (
		<div className="page-header wrapper">
			<h1 className="page-header__heading">{ props.heading }</h1>
		</div>
	)
}